import { NgModule } from '@angular/core'
import { EntityHubSmartComponent } from './entity-hub-smart.component'
import { CollectionsBaseModule } from '../collections/collections-base.module'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { EntityHubContentExperimentComponent } from './entity-hub-content-experiment.component'
import { SharedModule } from '../shared/shared.module'
import { ErrorModule } from '../libs/error/error.module'
import { EntityHubLayoutModule } from '../libs/_layouts/entity-hub-layout/entity-hub-layout.module'

@NgModule({
  imports: [CommonModule, SharedModule, RouterModule, CollectionsBaseModule, ErrorModule, EntityHubLayoutModule],
  declarations: [EntityHubSmartComponent, EntityHubContentExperimentComponent],
  exports: [EntityHubSmartComponent]
})
export class EntityHubModule {}
